const compareArrays = (a, b) => {
  if (a.length !== b.length) {
    return false;
  }

  for (let i = 0; i < a.length; i += 1) {
    if (!b.includes(a[i])) {
      return false;
    }
  }

  return true;
};

export default compareArrays;
